import API_BASE_URL from '../Config';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export const getDepartamentos = async () => {
    const response = await fetch(`${API_BASE_URL}/departamentos`, {
        headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Error al listar departamentos');
    return response.json();
};

export const getDepartamentosPaginados = async (page = 0, size = 10, search = '') => {
    const response = await fetch(`${API_BASE_URL}/departamentos/page?page=${page}&size=${size}&search=${search}`, {
        headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Error al cargar departamentos paginados');
    return response.json();
};

export const getDepartamentoById = async (id) => {
    const response = await fetch(`${API_BASE_URL}/departamentos/${id}`, {
        headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Departamento no encontrado');
    return response.json();
};

export const createDepartamento = async (data) => {
    const response = await fetch(`${API_BASE_URL}/departamentos`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear departamento');
    return response.json();
};

export const updateDepartamento = async (id, data) => {
    const response = await fetch(`${API_BASE_URL}/departamentos/${id}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar departamento');
    return response.json();
};

export const deleteDepartamento = async (id) => {
    const response = await fetch(`${API_BASE_URL}/departamentos/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
    });
    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Error al eliminar departamento');
    }
};
